import React, { memo, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ActionList, Avatar, Box, Button, Icon } from '@node-space/ui-components'
import { ConnectionStatusTypes, NetworkConnectionViewTypes } from 'constants/bvnkNetwork'
import { BvnkNetworkConnection, ConnectionStatusType } from 'types/bvnkNetwork'
import ConnectionsEmptyState from './ConnectionsEmptyState'

export interface OutgoingPendingConnectionsProps {
  isUpdatingConnection: boolean
  outgoingPendingConnections: BvnkNetworkConnection[]
  updateConnection: (
    connection: BvnkNetworkConnection,
    connectionStatus: ConnectionStatusType
  ) => void
}

const OutgoingPendingConnections = ({
  outgoingPendingConnections,
  isUpdatingConnection,
  updateConnection,
}: OutgoingPendingConnectionsProps) => {
  const { t } = useTranslation()
  const [connectionToUpdate, setConnectionToUpdate] = useState<BvnkNetworkConnection>()

  const handleDisconnectConnection = (connection: BvnkNetworkConnection) => {
    setConnectionToUpdate(connection)
    updateConnection(connection, ConnectionStatusTypes.DISCONNECTED)
  }

  const actionItemListItems = useMemo(() => {
    return outgoingPendingConnections?.map(connection => {
      return {
        transparent: false,
        testId: `outgoing-pending-connection-list-item-${connection?.id}`,
        id: connection?.id,
        key: `connection-${connection?.id}-{isUpdatingConnection}`,
        Avatar: <Avatar name={connection?.details?.name} size="small" type="entity" />,
        title: connection?.details?.name,
        BodyPost: connection?.details?.description,
        ActionButton: (
          <Button
            variant="destructive-ghost"
            key={`connection-${connection?.id}-disconnect-button`}
            iconElement={<Icon name="Prohibit" size="small" />}
            onClick={() => handleDisconnectConnection(connection)}
            loading={isUpdatingConnection && connectionToUpdate?.id === connection?.id}
          >
            {t('bvnkNetwork.deleteRequest')}
          </Button>
        ),
      }
    })
  }, [outgoingPendingConnections, isUpdatingConnection, connectionToUpdate])

  if (!actionItemListItems?.length) {
    return (
      <ConnectionsEmptyState
        networkConnectionViewType={NetworkConnectionViewTypes.SENT_INVITATIONS_VIEW}
      />
    )
  } else {
    return (
      <Box flexCol>
        <ActionList id="outgoing-pending-connections-list" items={actionItemListItems} />
      </Box>
    )
  }
}

export default memo(OutgoingPendingConnections)
